export let GoldWeightUnit = /*#__PURE__*/function (GoldWeightUnit) {
  GoldWeightUnit["LUONG"] = "luong";
  GoldWeightUnit["CHI"] = "chi";
  GoldWeightUnit["PHAN"] = "phan";
  GoldWeightUnit["GRAM"] = "gram";
  GoldWeightUnit["OUNCE"] = "ounce";
  return GoldWeightUnit;
}({});
const TO_GRAM = {
  [GoldWeightUnit.PHAN]: 0.375,
  [GoldWeightUnit.CHI]: 3.75,
  [GoldWeightUnit.LUONG]: 37.5,
  [GoldWeightUnit.GRAM]: 1,
  [GoldWeightUnit.OUNCE]: 31.1035 // Troy ounce (ozt) — standard for gold
};
export function convertGoldWeight(value, from, to) {
  if (!Number.isFinite(value)) {
    throw new TypeError(`Gold weight value must be a finite number, got ${value}`);
  }
  if (value < 0) {
    throw new RangeError(`Gold weight value must be non-negative, got ${value}`);
  }
  const grams = value * TO_GRAM[from];
  return Math.round(grams / TO_GRAM[to] * 1000000) / 1000000;
}
export function roundGoldWeight(grams, decimals = 2) {
  if (decimals < 0) {
    throw new RangeError(`decimals must be non-negative, got ${decimals}`);
  }
  const factor = Math.pow(10, decimals);
  return Math.round((grams + Number.EPSILON) * factor) / factor;
}
export function parseGoldWeight(input) {
  if (!input || !input.trim()) {
    throw new Error('Invalid gold weight input: empty string');
  }

  // Each unit is matched at most once — inputs with repeated units (e.g. "1 chỉ 1 chỉ")
  // are not supported; only the first occurrence is counted.
  const patterns = [[/(\d+(?:\.\d+)?)\s*(?:lượng|luong)(?=\s|$)/i, GoldWeightUnit.LUONG], [/(\d+(?:\.\d+)?)\s*(?:chỉ|chi)(?=\s|$)/i, GoldWeightUnit.CHI], [/(\d+(?:\.\d+)?)\s*(?:phân|phan)(?=\s|$)/i, GoldWeightUnit.PHAN], [/(\d+(?:\.\d+)?)\s*gram(?=\s|$)/i, GoldWeightUnit.GRAM], [/(\d+(?:\.\d+)?)\s*ounce(?=\s|$)/i, GoldWeightUnit.OUNCE]];
  let totalGrams = 0;
  let matched = false;
  for (const [pattern, unit] of patterns) {
    const match = input.match(pattern);
    if (match) {
      totalGrams += parseFloat(match[1]) * TO_GRAM[unit];
      matched = true;
    }
  }
  if (!matched) {
    throw new Error(`Cannot parse gold weight: "${input}"`);
  }
  return Math.round(totalGrams * 1000000) / 1000000;
}
export function formatGoldWeight(grams) {
  if (!Number.isFinite(grams)) {
    throw new TypeError(`Gold weight grams must be a finite number, got ${grams}`);
  }
  if (grams < 0) {
    throw new RangeError(`Gold weight grams must be non-negative, got ${grams}`);
  }

  // Values smaller than 1 phân (0.375g) are rounded to the nearest phân.
  // This is acceptable in Vietnamese gold trade where phân is the smallest unit.
  const totalPhan = Math.round(grams / 0.375);
  const luong = Math.floor(totalPhan / 100);
  const chi = Math.floor(totalPhan % 100 / 10);
  const phan = totalPhan % 10;
  const parts = [];
  if (luong > 0) parts.push(`${luong} lượng`);
  if (chi > 0) parts.push(`${chi} chỉ`);
  if (phan > 0) parts.push(`${phan} phân`);
  return parts.length > 0 ? parts.join(' ') : '0 phân';
}
//# sourceMappingURL=gold-weight.js.map